var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMedClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_med_close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5367656,1.25105133 C11.8715007,0.916316223 12.4142136,0.916316223 12.7489487,1.25105133 C13.0836838,1.58578644 13.0836838,2.12849928 12.7489487,2.46323438 L12.7489487,2.46323438 L8.212,7 L12.7489487,11.5367656 C13.0557892,11.8436061 13.0813592,12.3252057 12.8256588,12.6611727 L12.7489487,12.7489487 C12.4142136,13.0836838 11.8715007,13.0836838 11.5367656,12.7489487 L11.5367656,12.7489487 L7,8.212 L2.46323438,12.7489487 C2.15639387,13.0557892 1.67479429,13.0813592 1.33882726,12.8256588 L1.25105133,12.7489487 C0.916316223,12.4142136 0.916316223,11.8715007 1.25105133,11.5367656 L1.25105133,11.5367656 L5.788,7 L1.25105133,2.46323438 C0.944210815,2.15639387 0.918640773,1.67479429 1.1743412,1.33882726 L1.25105133,1.25105133 C1.58578644,0.916316223 2.12849928,0.916316223 2.46323438,1.25105133 L2.46323438,1.25105133 L7,5.788 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_med_close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#B1B1B1",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedClose);
export default __webpack_public_path__ + "static/media/icon_med_close.f28a06204c7b33779693708c1710b147.svg";
export { ForwardRef as ReactComponent };